/*!

 =========================================================
 * Vue Light Bootstrap Dashboard - v2.0.0 (Bootstrap 4)
 =========================================================

 * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from "vue";
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueRouter from "vue-router";
import App from "./App.vue";
import VModal from "vue-js-modal";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueHtmlToPaper from "./tmp_includes/vue-html-to-paper/build/vue-html-to-paper.js";
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'


const options = {
  name: '_blank',
  specs: [
    'fullscreen=no',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
  ],
  "autoClose": true,
}

// LightBootstrap plugin
import LightBootstrap from "./light-bootstrap-main";

// router setup
import routes from "./routes/routes";

import "./registerServiceWorker";
// plugin setup
Vue.use(VueRouter);
Vue.use(LightBootstrap);
Vue.use(VModal);
Vue.use(XLSX);
Vue.use(VueAxios, axios);
Vue.use(VueHtmlToPaper, options);
Vue.use(require('vue-moment'));
Vue.component('Loading', Loading);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);


Vue.prototype.$xlsx = XLSX;
Vue.prototype.$saveAs = saveAs;
Vue.prototype.$axios = axios;
Vue.prototype.$urlApi =  'http://tracking.keylogistic.com.br:8020/dados-api/public'; 
 
// configure router
const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: "nav-item active",
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

/**
 * Interceptador de requisições e resposta
 */
axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  return config;
}, function (error) {
  alert(error.request);
  return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  alert(error.response.data.message);
  console.log(error.response.data.message);
  return Promise.reject(error);
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router
});
